import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-topographic-code-assignment-form/configuration-automation-personnel-entities-association-modal-topographic-code-assignment-form.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-department-type-assignment-form/configuration-automation-personnel-entities-association-modal-department-type-assignment-form.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-most-likely-morphologic-code-assignment-form/configuration-automation-personnel-entities-association-modal-most-likely-morphologic-code-assignment-form.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-weekday-assignment-form/configuration-automation-personnel-entities-association-modal-weekday-assignment-form.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-number-assignment-form/configuration-automation-personnel-entities-association-modal-number-assignment-form.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-procedure-assignment-form/configuration-automation-personnel-entities-association-modal-procedure-assignment-form.vue'
import ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentForm
    from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-sample-type-assignment-form/configuration-automation-personnel-entities-association-modal-sample-type-assignment-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal/configuration-automation-personnel-entities-association-modal.model'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'

@Component({
    components: {
        ConfigurationAutomationPersonnelEntitiesAssociationModalTopographicCodeAssignmentForm,
        ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentForm,
        ConfigurationAutomationPersonnelEntitiesAssociationModalMostLikelyMorphologicCodeAssignmentForm,
        ConfigurationAutomationPersonnelEntitiesAssociationModalNumberAssignmentForm,
        ConfigurationAutomationPersonnelEntitiesAssociationModalProcedureAssignmentForm,
        ConfigurationAutomationPersonnelEntitiesAssociationModalSampleTypeAssignmentForm,
        ConfigurationAutomationPersonnelEntitiesAssociationModalWeekdayAssignmentForm
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModal extends Vue {
    @Ref() readonly entitiesAssociationModal!: BModal

    @Prop(String) readonly actionTitle!: string

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalState()
    }

    async show(personnel?: ConfigurationPersonnelResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalState()
        if (personnel) {
            this.state.personnel = personnel
        }

        this.entitiesAssociationModal.show()
    }

    hide(): void {
        this.entitiesAssociationModal.hide()
    }
}
